import React, { useEffect, useState } from 'react';
import Autocomplete from '@material-ui/lab/Autocomplete';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import {
    useStylesUp, useStylesHed, useStylesAuto, useStylesAutoPurch, useStylesTF, useStylesTD, useStylesBA, useStylesLbl
    , useStylesUiElemment,
    useStylesSpDial,
} from '../../../../St/Reports/UseStyle';
//=====================================================================
import { useTranslation } from "react-i18next";
import { useStylesContainers } from '../../../../St/comps/UseStyle';
import { ButtonBase } from '@material-ui/core';

export default function FoundationsFirstPanel(props) {

    const {
        AutoOptions,
        changTField,
        params,
        clasess,
        handleFileInputChange,
        fileImg,
        valueAutos,
        changAutos
    } = props;

    const clasup = useStylesUp();
    const calsPurch = useStylesAutoPurch();


    const clsConts = useStylesContainers();
    const clasAo = useStylesAuto();
    const clasTF = useStylesTF();
    const clasTD = useStylesTD();
    const claslbl = useStylesLbl();
    const { t } = useTranslation(["forms", "translation"]);

    const [showPic, setShowPic] = useState(false);
    return (
        <React.Fragment>
            <Grid container  justifyContent="center" spacing={2}>
                <Grid
                    item
                    container
                    spacing={1}
                    // justifyContent='center'
                    lg={12} md={12} sm={12} xs={12}
                >
                    <Grid item lg={6} md={6} sm={6} xs={12}>
                        <Autocomplete
                            classes={clasAo}
                            value={valueAutos.branch}
                            labelPlacement=""
                            onChange={(event, newValue) => {
                                changAutos("branch", newValue);
                            }}
                            id="controllable-states-demo"
                            size="small"
                            options={AutoOptions?.Branches}
                            getOptionLabel={(option) =>
                                typeof option === "string" ? option : option.name
                            }
                            // style={{  }}
                            disableClearable
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    label={t("forms:branch")}
                                    variant="outlined"
                                    size="small"
                                    InputLabelProps={{ className: claslbl.clrBlackLbl }}
                                />
                            )}
                        />
                    </Grid>
                    <Grid item lg={6} md={6} sm={6} xs={12}>

                    </Grid>
                    <Grid item lg={6} md={6} sm={6} xs={12} style={{ paddingBottom: "0.5rem" }}>
                        <TextField
                            fullWidth
                            variant="outlined"
                            size="small"
                            id="nameA"

                            label={t("forms:foundation-name-ar")}
                            //className={clasTF.clrBlack}
                            InputLabelProps={{ className: claslbl.clrBlackLblS }}
                            InputProps={{ className: claslbl.clrBlackTxt, }}
                            // InputProps={{ className: clasTD.input, readOnly: true }}
                            type="text"
                            name="nameA"
                            value={params.nameA}

                            onChange={changTField("nameA")}
                        />
                    </Grid>

                    <Grid item lg={6} md={6} sm={6} xs={12} style={{ paddingBottom: "0.5rem" ,direction:"ltr"}}>
                        <TextField
                            fullWidth
                            variant="outlined"
                            size="small"
                            id="nameE"
                            label={t("forms:foundation-name-en")}
                            type="text"
                            name="nameE"
                            value={params.nameE}
                            InputLabelProps={{
                                className: claslbl.clrBlackLblS,

                            }}
                            InputProps={{ className: claslbl.clrBlackTxt }}
                            onChange={changTField("nameE")}
                        />
                    </Grid>

                    <Grid item lg={6} md={6} sm={6} xs={12} style={{ paddingBottom: "0.5rem" }}>
                        <TextField
                            fullWidth
                            variant="outlined"
                            size="small"
                            id="FieldA"
                            label={t("forms:business-activity")}
                            type="text"
                            name="FieldA"
                            value={params.FieldA}
                            InputLabelProps={{ className: claslbl.clrBlackLblS,  }}
                            InputProps={{ className: claslbl.clrBlackTxt }}
                            onChange={changTField("FieldA")}
                        />
                    </Grid>

                    <Grid item lg={6} md={6} sm={6} xs={12} style={{ paddingBottom: "0.5rem",direction:"ltr" }}>
                        <TextField
                            fullWidth
                            variant="outlined"
                            size="small"
                            id="FieldA"
                            label={t("forms:business-activity-en")}
                            type="text"
                            name="FieldA"
                            value={params.FieldE}
                            InputLabelProps={{
                                className: claslbl.clrBlackLblS,

                            }}
                            InputProps={{ className: claslbl.clrBlackTxt }}
                            onChange={changTField("FieldE")}
                        />
                    </Grid>


                    <Grid item lg={4} md={4} sm={6} xs={12} style={{ paddingBottom: "0.5rem" }}>
                        <TextField
                            fullWidth
                            variant="outlined"
                            size="small"
                            id="bsn_no"
                            label={t("forms:commercial-registration-no")}
                            type="text"
                            name="bsn_no"
                            value={params.bsn_no}
                            InputLabelProps={{ className: claslbl.clrBlackLblS }}
                            InputProps={{ className: claslbl.clrBlackTxt, }}
                            onChange={changTField("bsn_no")}
                        />
                    </Grid>

                    <Grid item lg={4} md={4} sm={6} xs={12} style={{ paddingBottom: "0.5rem" }}>
                        <TextField
                            fullWidth
                            variant="outlined"
                            size="small"
                            id="Tel"
                            label={t("forms:phone-number")}
                            type="text"
                            name="Tel"
                            value={params.Tel}
                            InputLabelProps={{ className: claslbl.clrBlackLblS }}
                            InputProps={{ className: claslbl.clrBlackTxt, }}
                            onChange={changTField("Tel")}
                        />
                    </Grid>
                    <Grid item lg={4} md={4} sm={6} xs={12} style={{ paddingBottom: "0.5rem" }}>
                        <TextField
                            fullWidth
                            variant="outlined"
                            size="small"
                            id="FieldA"
                            label={t("forms:fax-number")}
                            type="text"
                            name="Fax"
                            value={params.Fax}
                            InputLabelProps={{ className: claslbl.clrBlackLblS }}
                            InputProps={{ className: claslbl.clrBlackTxt, }}
                            onChange={changTField("Fax")}
                        />
                    </Grid>
                    <Grid item lg={4} md={4} sm={6} xs={12} style={{ paddingBottom: "0.5rem" }}> 
                        <TextField
                            fullWidth
                            variant="outlined"
                            size="small"
                            id="FieldA"
                            label={t("forms:mobile-number")}
                            type="text"
                            name="FieldA"
                            value={params.Mobile}
                            InputLabelProps={{ className: claslbl.clrBlackLblS }}
                            InputProps={{ className: claslbl.clrBlackTxt, }}
                            onChange={changTField("Mobile")}
                        />
                    </Grid>

                    <Grid item lg={4} md={4} sm={6} xs={12} style={{ paddingBottom: "0.5rem" }}>
                        <TextField
                            fullWidth
                            variant="outlined"
                            size="small"
                            id="FieldA"
                            label={t("forms:email")}
                            type="text"
                            name="Email"
                            value={params.Email}
                            InputLabelProps={{ className: claslbl.clrBlackLblS }}
                            InputProps={{ className: claslbl.clrBlackTxt, }}
                            onChange={changTField("Email")}
                        />
                    </Grid>


                    <Grid item lg={4} md={4} sm={4} xs={12} style={{ paddingBottom: "0.5rem" }}>
                        <TextField
                            fullWidth
                            variant="outlined"
                            size="small"
                            id="nameEN"
                            label={t("forms:tax-number")}
                            InputLabelProps={{ className: claslbl.clrBlackLblS }}
                            InputProps={{ className: claslbl.clrBlackTxt, }}
                            type="number"
                            name="tax_no"
                            value={params.tax_no}
                            onChange={changTField("tax_no")}
                        />
                    </Grid>

    
                    <Grid item lg={12} md={12} sm={12} xs={12} style={{ paddingBottom: "0.5rem" }}>
                        <TextField
                            fullWidth
                            variant="outlined"
                            size="small"
                            id="Address"
                            label={t("forms:address")}
                            InputLabelProps={{ className: claslbl.clrBlackLbl }}
                            InputProps={{ className: claslbl.clrBlackTxt }}
                            type="text"
                            name="Address"
                            value={params?.Address}
                            onChange={changTField("Address")}
                        />
                    </Grid>

                    <Grid item lg={12} md={12} sm={12} xs={12} style={{ paddingBottom: "0.5rem" }}>
                        <TextField
                            fullWidth
                            variant="outlined"
                            size="small"
                            id="BillNotes"
                            label={t("forms:invoice-footer-notes")}
                            InputLabelProps={{ className: claslbl.clrBlackLbl }}
                            InputProps={{ className: claslbl.clrBlackTxt }}
                            type="text"
                            name="BillNotes"
                            multiline
                            value={params.BillNotes}
                            onChange={changTField("BillNotes")}
                        />
                    </Grid>

                    <Grid item container lg={12} md={12} sm={12} xs={12}>

                        <Grid item container lg={10} md={10} sm={10} xs={8} spacing={1}>

                            <Grid item lg={12} md={12} sm={12} xs={12} style={{ paddingBottom: "0.5rem" }}>
                                <TextField
                                    fullWidth
                                    variant="outlined"
                                    size="small"
                                    id="website"
                                    label={t("forms:website")}
                                    InputLabelProps={{ className: claslbl.clrBlackLbl }}
                                    InputProps={{ className: claslbl.clrBlackTxt }}
                                    type="text"
                                    name="Address"
                                    value={params?.website}
                                    onChange={changTField("website")}
                                />
                            </Grid>


                            <Grid item lg={12} md={12} sm={12} xs={12} style={{ paddingBottom: "0.5rem" }}>
                                <TextField
                                    fullWidth
                                    variant="outlined"
                                    size="small"
                                    id="MailBox"
                                    label={t("forms:mailbox")}
                                    InputLabelProps={{ className: claslbl.clrBlackLbl }}
                                    InputProps={{ className: claslbl.clrBlackTxt }}
                                    type="text"
                                    name="MailBox"
                                    value={params?.MailBox}
                                    onChange={changTField("MailBox")}
                                />
                            </Grid>


                        </Grid>

                        <Grid item container lg={2} md={2} sm={2} xs={4}>
                            <Grid
                                className={clasess.imageLogo}
                                item
                                lg={2}
                                md={2}
                                sm={2}
                                xs={2}
                            >
                                <input
                                    accept="image/*"
                                    className={clasess.input}
                                    id="contained-button-file"
                                    multiple
                                    name="Logo" //value={data.Logo.toString()}
                                    type="file"
                                    onChange={handleFileInputChange}
                                />
                                <label htmlFor="contained-button-file">
                                    <ButtonBase
                                        style={{ border: "solid 1px" }}
                                        variant="contained"
                                        color="primary"
                                        component="span"
                                    >
                                        <img
                                            src={` ${fileImg.baseURL ? fileImg.code8 : fileImg.code64}
                  ${params.Logo}
                  `}
                                            style={{ height: 100, width: 100 }}
                                            alt={params.nameA}
                                        />
                                    </ButtonBase>
                                </label>
                            </Grid>
                        </Grid>

                    </Grid>




                </Grid>
            </Grid>



        </React.Fragment>
    );

}